import React from "react";
import { ToggleButtonGroup, ToggleButton, Tooltip } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import SplitscreenOutlinedIcon from "@mui/icons-material/SplitscreenOutlined";

type Props = {
  editorLayoutConfiguration: "transcript" | "canvas" | "split";
  setEditorLayoutConfiguration: (layout: "transcript" | "canvas" | "split") => void;
};

const V2EditorLayoutToggle: React.FC<Props> = ({
  editorLayoutConfiguration, setEditorLayoutConfiguration
}) => {
  const mode = editorLayoutConfiguration;

  const handleChange = (_e: any, value: "transcript" | "canvas" | "split" | null) => {
    if (!value) return;
    setEditorLayoutConfiguration(value);
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={handleChange}
      sx={{
        borderRadius: "10px",
        border: "1px solid var(--app-border-subtle)",
        overflow: "hidden",
        backgroundColor: "var(--app-bg-surface)",
        "& .MuiToggleButton-root": {
          minWidth: 36,
          px: 1,
          py: 0.25,
          color: "var(--app-text-muted)",
          border: "none",
          "&.Mui-selected": {
            backgroundColor: "rgba(43, 107, 253, 0.16)",
            color: "var(--app-text-primary)",
            "&:hover": { backgroundColor: "rgba(43, 107, 253, 0.24)" },
          },
          "&:hover": { backgroundColor: "var(--app-bg-subtle)" },
        },
      }}
    >
      <ToggleButton value="transcript">
        <Tooltip title="Transcript">
          <span>
            <ArticleOutlinedIcon sx={{ fontSize: 16, marginTop: 0.5 }} />
          </span>
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="canvas">
        <Tooltip title="Canvas & Timeline">
          <span>
            <SlideshowOutlinedIcon sx={{ fontSize: 16, marginTop: 0.5 }} />
          </span>
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="split">
        <Tooltip title="Split view">
          <span>
            <SplitscreenOutlinedIcon sx={{ fontSize: 16, marginTop: 0.5 }} />
          </span>
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default V2EditorLayoutToggle;

